// Imports
import React, { Component } from 'react';

// CSS
import './../styles/css/rocketship.css';

class Rocketship extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div className="rocketship">
                <div className="exhaust-fumes">
                    <ul>
                        <li />
                        <li />
                        <li />
                        <li />
                        <li />
                        <li />
                        <li />
                        <li />
                        <li />
                    </ul>
                </div>

                <div className="rocket">
                    <div className="rocket-body">
                        <div className="body"></div>
                        <div className="body-cap"></div>
                        <div className="fin-sides fin-left"></div>
                        <div className="fin-sides fin-right"></div>
                        <div className="fin-middle"></div>
                        <div className="window"></div>
                        <div className="window-tint"></div>
                    </div>
                    <div className="exhaust-flame"></div>
                </div>
            </div>
        );
    }
}

export default Rocketship;
